<template>
    <div>

        <div class="map-cats">

            <div v-if="isContentBlocked" class="map-blocker filters" data-modal="join-the-club" ></div>

            <!-- Filter by Category -->
            <div class="map-cat-buttons">

                <ais-refinement-list class="filter-by-category" :sort-by="['label']" attribute="category.title">
                    <template v-slot:item="{ item, refine }">
                        <span :class="categoryClass(item)" @click="refine(item.value)">
                          {{  item.label }}
                          <svg class="close"><use xlink:href="#close"></use></svg>
                        </span>
                    </template>
                </ais-refinement-list>

            </div>

            <!-- Other Filters -->
            <button type="button" class="filter-toggle" @click="toggleFilters()">
                <span class="text-close">
                    Close
                    <svg class="close"><use xlink:href="#close"></use></svg>
                </span>
                <span class="text-open">
                  Filter
                  <svg class="filter"><use xlink:href="#filter"></use></svg>
                </span>
            </button>

        </div>

        <div class="map-filters filter-active">

            <!-- In My Whislist OnlY -->
<!--            <section class="filter-section" id="on-my-list">-->
<!--                <h3 class="filter-info-popup-trigger">-->
<!--                    My List Only-->
<!--                    <span>-->
<!--                        <svg class="info-icon"><use xlink:href="#info-icon"></use></svg>-->
<!--                    </span>-->
<!--                </h3>-->
<!--                <OnMyListTooltip />-->
<!--                <div class="wishlist-switch"-->
<!--                     @click="filters.wishlist = !filters.wishlist"-->
<!--                     :class="{ 'active': filters.wishlist }">-->
<!--                    <span></span>-->
<!--                </div>-->
<!--            </section>-->

            <!-- Is Verified -->
            <section class="filter-section" id="verified-wt">
                <h3 class="filter-info-popup-trigger">
                    Verified By WT
                    <span>
                        <svg class="info-icon"><use xlink:href="#info-icon"></use></svg>
                    </span>
                </h3>
                <VerfiedWtTooltip />
                <ais-toggle-refinement attribute="is_verified" label="Is Verified">
                    <template v-slot="{ value, refine, createURL, sendEvent }">
                        <div class="wishlist-switch"
                             @click.prevent="refine(value)"
                             :class="{ 'active': value.isRefined }">
                            <span></span>
                        </div>
                    </template>
                </ais-toggle-refinement>
            </section>

            <!-- Price -->
            <section class="filter-section" id="price-section">
                <h3 class="filter-info-popup-trigger">
                    Price
                    <span>
                        <svg class="info-icon"><use xlink:href="#info-icon"></use></svg>
                    </span>
                </h3>
                <PriceInfoTooltip />

                <ais-refinement-list attribute="price" :sort-by="['price']">
                    <template v-slot="{ items, isShowingMore, isFromSearch, canToggleShowMore, refine, createURL, toggleShowMore, searchForItems, sendEvent, }">

                        <div class="price-filters">
                            <span v-for="item in items"
                                  @click.prevent="refine(item.value)"
                                  :class="{ 'active': item.isRefined }" v-text="repeatString('$', (item.value))">
                            </span>
                        </div>
                    </template>
                </ais-refinement-list>
            </section>

            <!-- Neightbourhood -->
            <ais-refinement-list class="filter-section" :limit="21" :show-more-limit="100" attribute="neighborhood.title" :sort-by="['value']" searchable show-more>
                    <template v-slot="{ items, isShowingMore, isFromSearch, canToggleShowMore, refine, createURL, toggleShowMore, searchForItems, sendEvent, }">
                        <h3 v-text="pluralize(city.neighborhoods_label, items.length)"></h3>
                        <div class="filter-section-content"  v-if="items.length">
                            <div class="check-grid">
                                <label v-for="item in items" :key="item.value">
                                    <input type="checkbox" :checked="item.isRefined" :value="item.value" @click="refine(item.value)" />
                                    <span><svg class="solo-check"><use xlink:href="#solo-check"></use></svg></span>
                                    {{ item.value }}
                                </label>
                            </div>
                            <button type="button"
                                    v-if="canToggleShowMore"
                                    @click="toggleShowMore"
                                    class="more-checks-toggle on-vue"
                                    :class="{'active': isShowingMore}">
                                <span></span>
                                <svg class="arrow-down"><use xlink:href="#arrow-down"></use></svg>
                            </button>
                        </div>
                    </template>
                </ais-refinement-list>

            <!-- Eat Options -->
            <ais-refinement-list class="filter-section" :limit="21" :show-more-limit="100" attribute="eat_options" :sort-by="['value']" searchable show-more>
                    <template v-slot="{ items, isShowingMore, isFromSearch, canToggleShowMore, refine, createURL, toggleShowMore, searchForItems, sendEvent, }">
                        <h3>Cuisine</h3>
                        <div class="check-grid">
                            <label v-for="option in items" :key="option.value">
                                <input type="checkbox":checked="option.isRefined" :value="option.value" @click="refine(option.value)" />
                                <span><svg class="solo-check"><use xlink:href="#solo-check"></use></svg></span>
                                {{ option.value }}
                            </label>
                        </div>
                        <button type="button"
                                v-if="canToggleShowMore"
                                @click="toggleShowMore"
                                class="more-checks-toggle on-vue"
                                :class="{'active': isShowingMore}">
                                <span></span>
                                <svg class="arrow-down"><use xlink:href="#arrow-down"></use></svg>
                            </button>
                    </template>
                </ais-refinement-list>

            <!-- Play Options -->
            <ais-refinement-list class="filter-section" :limit="21" :show-more-limit="100" attribute="play_options" searchable show-more>
                    <template v-slot="{ items, isShowingMore, isFromSearch, canToggleShowMore, refine, createURL, toggleShowMore, searchForItems, sendEvent, }">
                        <h3>Type</h3>
                        <div class="check-grid">
                            <label v-for="option in items" :key="option.value">
                                <input type="checkbox":checked="option.isRefined" :value="option.value" @click="refine(option.value)" />
                                <span><svg class="solo-check"><use xlink:href="#solo-check"></use></svg></span>
                                {{ option.value }}
                            </label>
                        </div>
                        <button type="button"
                                v-if="canToggleShowMore"
                                @click="toggleShowMore"
                                class="more-checks-toggle on-vue"
                                :class="{'active': isShowingMore}">
                            <span></span>
                            <svg class="arrow-down"><use xlink:href="#arrow-down"></use></svg>
                        </button>
                    </template>
                </ais-refinement-list>

            <!-- Tags Filter -->
            <ais-refinement-list class="filter-section" :limit="21" :show-more-limit="100" attribute="tags" :sort-by="['value']" searchable show-more>
                    <template v-slot="{ items, isShowingMore, isFromSearch, canToggleShowMore, refine, createURL, toggleShowMore, searchForItems, sendEvent, }">
                        <h3>Good For</h3>
                        <div class="check-grid">
                            <label v-for="option in items" :key="option.value">
                                <input type="checkbox":checked="option.isRefined" :value="option.value" @click="refine(option.value)" />
                                <span><svg class="solo-check"><use xlink:href="#solo-check"></use></svg></span>
                                {{ option.value }}
                            </label>
                        </div>
                        <button type="button"
                                v-if="canToggleShowMore"
                                @click="toggleShowMore"
                                class="more-checks-toggle on-vue"
                                :class="{'active': isShowingMore}">
                            <span></span>
                            <svg class="arrow-down"><use xlink:href="#arrow-down"></use></svg>
                        </button>
                    </template>
                </ais-refinement-list>

            <!-- Bottom Buttons -->
            <ais-stats>
                <template v-slot="{ hitsPerPage, nbPages, nbHits, page, processingTimeMS, query }">
                    <div class="filtered-controls">
                        <ais-clear-refinements>
                            <template v-slot="{ canRefine, refine, createURL }">
                                <button :disabled="!canRefine" class="clear-filters" @click.prevent="refine">Clear</button>
                            </template>
                        </ais-clear-refinements>
                        <span class="show-filters" @click="toggleFilters()">
                            Close Filters
                            <small v-if="nbHits" v-text="pluralize('spot', nbHits, true)"></small>
                            <small v-else>No Results</small>
                        </span>
                    </div>
                </template>
            </ais-stats>

        </div>

    </div>

</template>

<script>

import Helpers from '@/mixins/Helpers'
import PriceInfoTooltip from '../../Cities/SpotPriceInfoTooltip'
import VerfiedWtTooltip from '../../Cities/VerfiedWtTooltip'
import OnMyListTooltip from '../../Cities/OnMyListTooltip'

export default {

    mixins: [Helpers],

    props: ['city', 'isContentBlocked'],

    components: {
        VerfiedWtTooltip,
        OnMyListTooltip,
        PriceInfoTooltip
    },

    data() {
        return {
            sidebar: null,
            toggle: false,
        }
    },

    mounted() {
        this.sidebar = document.getElementsByClassName('map-sidebar')[0]
    },

    methods: {

        categoryClass(item) {
            let css = `bg-${item.value}`
            if (!item.isRefined) {
                css = css + ' dis';
            }
            return css
        },

        toggleFilters() {
            this.toggle = this.sidebar.classList.contains('filtered')
            if (this.toggle) {
                $('.map-sidebar').removeClass('filtered')
            } else {
                $('.map-sidebar').addClass('filtered')
            }
        },

        clearFilters() {

        },
    }
}
</script>
